import { GetPortfolioCompanyById } from '../../common/api/PortcoAPIHelper';
import { GetAllInvestments } from '../../common/api/InvestmentAPIHelper';
import { GetAllFunds } from '../../common/api/FundAPIHelper';
import { GetAllInvestmentRounds } from '../../common/api/InvestmentRoundAPIHelper';
import { GetAllInvestmentTypes } from '../../common/api/InvestmentTypeAPIHelper';
import { getInsightsForPortco } from '../../common/api/PortcoInsightsAPIHelper';
export const fetchPortfolioById = async (portcoId) => {
    try {
        console.log("PortfolioCompanyHelper :: fetchPortfolioById :: Start")
        const [portfolio, investments, fundsResponse, investmentRoundsResponse, investmentTypesResponse] = 
            await Promise.all([
                GetPortfolioCompanyById(portcoId),
                GetAllInvestments(),
                GetAllFunds(),
                GetAllInvestmentRounds(),
                GetAllInvestmentTypes()
            ]);

        const funds = JSON.parse(fundsResponse.body);
        const investmentRounds = JSON.parse(investmentRoundsResponse.body);
        const investmentTypes = JSON.parse(investmentTypesResponse.body);
        const relatedInvestments = investments.filter(investment => Number(investment.portco_id) === Number(portcoId));

        // Check if pitchbook_id is present in the portfolio
        let portfolioInsights = null;
        if(portfolio.pitchbook_id){
          portfolioInsights = await getInsightsForPortco(portfolio.pitchbook_id);
        }

        const investmentDetails = relatedInvestments.map(investment => {
            const fund = funds.find(fund => fund.internal_fund_id === investment.internal_fund_id);
            const investmentRound = investmentRounds.find(round => round.investment_round_id === investment.investment_round_id);
            const investmentType = investmentTypes.find(investmentType => investmentType.investment_type_id === investment.investment_type_id);
            return {
                investmentId: investment.investment_id,
                investmentAmount: investment.investment_amount,
                investmentDate: investment.investment_date,
                fundId: fund?.internal_fund_id,
                fundName: fund?.fund_name,
                currentAum: fund?.current_aum,
                portcoId:  portfolio?.portco_id,
                portcoName: portfolio?.company_name,
                investmentRoundId: investmentRound?.investment_round_id,
                investmentRound: investmentRound?.investment_round_name,
                investmentTypeId: investmentType?.investment_type_id,
                investmentType: investmentType?.investment_type_name,
                percentOfFundAum: (Number(investment.investment_amount) / Number(fund?.current_aum)).toFixed(4)
            };
        });

        console.log("PortfolioCompanyHelper :: fetchPortfolioById :: End")
        return {
            portfolio,
            investmentDetails,
            portfolioInsights
        };
    } catch (error) {
        console.error(error);
        return null;
    }
};
